


















import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { ISos } from '@/store/modules/views/sos/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class EditSosDialog extends VueExtendedBaseComponent {

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get fieldValidate() {
    return this.formInstant.validate()
  }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get editSosDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editSosAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get validateInput() {

    return this.nameValidate(this.name)
  }
  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private sos!: ISos & {roles: string[], permissions: string[], accounts: string[]}
  private loading = false
  private urlSos = ''

  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private activePicker = null
  private valid = false
  private name = ''
  private snackbar = false
  private phoneNumber = ''

  private async created() {
    this.name = this.sos.name || ''
    this.phoneNumber = this.sos.phone || ''
    this.urlSos = `${process.env.VUE_APP_API_URL}/v1/all/sos/${this.sos._id}`
  }

  private requireInput(value) {  return value !== '' || 'จำเป็นต้องกรอก' }

  get invalidateInput() {
    return _.some(
        [],
        (item) => item !== true,
    )
  }

  private async editSosAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      const sosData = {
        edit: {
          name: this.name,
          phone: this.phoneNumber,
        },
      }
      try {
        await Promise.all([
          HttpRequestServiceWithToken.put(this.urlSos, sosData.edit),
        ])
        this.updateSnackbar({txt: 'แก้ไขเบอร์โทรศัพทฉุกเฉินสำเร็จ', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        this.loading = false
      }
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
